export default __webpack_public_path__ + "static/media/slide1.ce2fa051.jpeg";